import initRouter from './index'
import { Page } from './views'

/**
 * @function defineRouter
 *
 * @param {Store} store Instance of Vuex Store; used to sync router to correct store
 */
export default function defineRouter (store) {
  const routes = [
    {
      path: '/',
      name: 'home',
      component: Page,
      meta: {
        feeder: `/page/hello.json`,
      },
    },
    {
      path: '/the-work/:slug',
      name: 'work-detail',
      component: Page,
      meta: {
        feeder: `/work/:slug.json`,
      },
    },
    {
      path: '/:slug',
      name: 'page',
      component: Page,
      meta: {
        feeder: `/page/:slug.json`,
      },
    },
  ]

  let beforeEach = (to, from, next) => {
    store.dispatch('setLoading', true)
    next()
  }

  return initRouter(routes, store, { beforeEach })
}
